import { NgModule } from '@angular/core';
import { ChatCoreBotInputComponent } from './chat-core-bot-input.component';
import { ChatCoreBotMessageComponent } from './chat-core-bot-message.component';
import { ChatCoreBotRatingComponent } from './chat-core-bot-rating.component';
import { ChatCoreBotComponent } from './chat-core-bot.component';
import { ChatCoreLiveComponent } from './chat-core-live.component';
import { ChatCorePanelComponent } from './chat-core-panel.component';
import { ChatCoreToggleButtonComponent } from './chat-core-toggle-button.component';
import { NoResourceSanitizePipe } from './pipes/no-res-sanitize.pipe';
import { NoSanitizePipe } from './pipes/no-sanitize.pipe';
import { ApiService } from './services/api.service';

@NgModule({
    declarations: [
        ChatCoreBotComponent,
        ChatCoreBotInputComponent,
        ChatCoreBotMessageComponent,
        ChatCoreBotRatingComponent,
        ChatCoreLiveComponent,
        ChatCorePanelComponent,
        ChatCoreToggleButtonComponent,
        NoResourceSanitizePipe,
        NoSanitizePipe,
    ],
    exports: [NoResourceSanitizePipe, NoSanitizePipe],
    providers: [ApiService, NoResourceSanitizePipe, NoSanitizePipe],
})
export class ChatCoreModule {}
